import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

import { Modal } from '@ui/uikit/components/common/Modal';
import type { ReportFormData, ReviewOptionType } from '@ui/uikit/components/common/VotingDropdownMenu';
import { getErrorMessage } from '@utilities/errors/getErrorMessage';

import { DialogLayout } from '../../../Dialog';
import styles from './ReportDialog.module.scss';
import { ReportDialogContent } from './ReportDialogContent';

export type FeedbackType = 'Review' | 'Suggestion';

interface ReportDialogProps {
  isOpen?: boolean;
  selectedReportType: string;
  onOpenChange: () => void;
  submitReview: (data: ReportFormData) => Promise<void>;
  reviewReportTypes: ReviewOptionType[];
  mode: FeedbackType;
  isReporting?: boolean;
}

const TITLE_BY_MODE: Record<FeedbackType, string> = {
  Review: 'Report Review',
  Suggestion: 'Report Suggestion',
};

const ReportDialog = ({
  isOpen,
  selectedReportType,
  onOpenChange,
  reviewReportTypes,
  submitReview,
  mode,
  isReporting,
}: ReportDialogProps) => {
  const form = useForm<ReportFormData>({
    defaultValues: {
      reportType: selectedReportType,
      reportText: '',
    },
  });

  const { handleSubmit } = form;

  const handleFormSubmit = handleSubmit(async (data) => {
    try {
      await submitReview(data);
    } catch (error) {
      toast.error(getErrorMessage(error));
    }
  });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onOpenChange}
    >
      <DialogLayout
        className={styles['container']}
        title={TITLE_BY_MODE[mode]}
        onSubmit={handleFormSubmit}
        onCancel={onOpenChange}
        isSubmitPending={isReporting}
      >
        <ReportDialogContent reviewReportTypes={reviewReportTypes} form={form} />
      </DialogLayout>
    </Modal>
  );
};

export { ReportDialog, type ReportFormData };
